import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import Notifications from 'vue-notification'
Vue.use(Notifications)
//===========sanitize================
// import VueSanitize from "vue-sanitize";
// let defaults = VueSanitize.defaults;
// //console.log('defaults',defaults)
// Vue.use(VueSanitize, defaults);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

import Datepicker from 'vue2-datepicker';
Vue.component('datepicker', Datepicker)

// import VueSecureHTML from 'vue-html-secure';
// Vue.use(VueSecureHTML);

// import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
//import dist/vue2-pdf-embed.js
// Vue.component('vue-pdf-embed', VuePdfEmbed)

//==============vue-editor=======================
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
//===============vue-chat-scroll=================
import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)
//================feather icons==================
import VueFeather from 'vue-feather';
Vue.use(VueFeather);
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
//================moment=========================
Vue.use(require('vue-moment'))
//================paginate=======================
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)
//==============vee-validate=====================
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);
//========local components import globally=======
import header from '@/components/website/shared/header'
Vue.component('app-header', header)
import top_header_title from '@/components/website/shared/top_header_title'
Vue.component('app-top-header-title', top_header_title)
import pagination from '@/components/website/shared/pagination'
Vue.component('app-pagination', pagination)
import loaderComponent from '@/components/website/shared/loader_component'
Vue.component('app-loader-component', loaderComponent)
import confirmation from '@/components/website/shared/confirmation'
Vue.component('app-confirm', confirmation)
import password_icon from './components/website/shared/password_icon'
Vue.component('passwordIcon', password_icon)
import html2canvas from 'html2canvas'
window.html2canvas = html2canvas

//=================import env variable===========================
Vue.prototype.$env_var = process.env
import * as moment from 'moment'

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js